<app-client-case-study [caseStudy]="caseStudy"></app-client-case-study>
